import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  // 認證頁面
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { guest: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { guest: true },
  },

  // 需要認證的頁面
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('@/views/dashboard/ProjectsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:id/settings',
    name: 'ProjectSettings',
    component: () => import('@/views/project/ProjectSettingsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/editor/:projectId',
    name: 'Editor',
    component: () => import('@/views/editor/EditorView.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/settings/profile',
    name: 'Profile',
    component: () => import('@/views/settings/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/subscription',
    name: 'Subscription',
    component: () => import('@/views/settings/SubscriptionView.vue'),
    meta: { requiresAuth: true },
  },

  // 公開分享頁面
  {
    path: '/s/:code',
    name: 'Share',
    component: () => import('@/views/share/ShareView.vue'),
    meta: { public: true },
  },

  // 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory('/app'),
  routes,
})

// 路由守衛
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // 初始化認證狀態
  if (!authStore.isAuthenticated && authStore.token) {
    await authStore.init()
  }

  // 需要認證的頁面
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  // 已登入用戶訪問訪客頁面
  if (to.meta.guest && authStore.isAuthenticated) {
    return next({ name: 'Dashboard' })
  }

  next()
})

export default router
